import * as styles from "./ArticleOrEventCard.module.scss";

import cx from "clsx";
import React from "react";
import LinkNoStyle from "../../common/LinkNoStyle/LinkNoStyle";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";
export const ArticleOrEventCard: React.FC<DogsTrust.SignPostCardProps> = ({
	imgSrc,
	title,
	noOrphan,
	buttonUrl,
}) => {
	return (
		<div
			className={cx(styles.articleeventcardcomponent, {
				[styles.noorphan]: noOrphan,
			})}
		>
			<LinkNoStyle
				to={buttonUrl}
				style={{
					position: "absolute",
					zIndex: "1",
					left: "2px",
					top: "2px",
					bottom: "2px",
					right: "2px",
					textIndent: "-1000px",
				}}
			>
				{title}
			</LinkNoStyle>
			<div className={styles.articleeventcardimage}>
				{imgSrc && (
					<ProcessedImage
						src={imgSrc}
						alt={title}
						dimensions="120x90"
						width={120}
						height={90}
						loading={"lazy"}
					/>
				)}
			</div>
			<div className={styles.articleeventcarddetails}>
				<div className={styles.articleeventcardtitle}>
					<h2 data-variation="hideFromJumpLinks" className={styles.title}>
						{title}
					</h2>
				</div>
			</div>
		</div>
	);
};

export default ArticleOrEventCard;
